
import AV from "leancloud-storage"
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "SignUpVerifyCode",
created() {
this.from = this.$route.query.from;
this.phone = (this.$route.query.phone || "").toString();
},
props: [],
data() {
return {
from: "",
code: "",
phone: "",
username: "",
password: "",
repassword: ""
};
},
methods: {
async verifyPhone() {
if (!this.phone) {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

if (!this.code) {
this.$vux.toast.text("验证码不能为空", "middle");
return;
}

if (!this.username) {
this.$vux.toast.text("用户名不能为空", "middle");
return;
}

if (!this.password) {
this.$vux.toast.text("密码不能为空", "middle");
return;
}

if (!this.repassword) {
this.$vux.toast.text("重复密码不能为空", "middle");
return;
}

if (this.password != this.repassword) {
this.$vux.toast.text("两次输入密码不一致", "middle");
return;
}

try {

await AV.Cloud.run("verifySMSCodeAndSignUp", { "mobilePhone": this.phone, code: this.code, client: "web", password: this.password, username: this.username })


await AV.User.logInWithMobilePhone(this.phone, this.password)

this.$vux.toast.text("注册成功", "middle");

this.$store.commit("logIn", User.current().toJSON());
this.$router.push({ path: this.from || "/" });
} catch (err) {
this.$vux.toast.text(err.rawMessage || err.message, "middle");
};
}
},
components: {
XInput,
Group,
XButton
}
};



// WEBPACK FOOTER //
// ./src/pages/account/SignUpVerifyPhone.vue